import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { SharedModule } from 'src/app/shared/shared.module';
import { SafetyComponent } from './safety.component';
import { SafetyRoutingModule } from './safety-routing.module';
import { SafetyWidgetComponent } from './safety-widget/safety-widget.component';
import { safetyReducer } from './state/safety.reducer';
import { SafetyEffects } from './state/safety.effects';
import { certificationMonitoringReducer } from './state/certification-monitoring.reducer';
import { CertificationMonitoringEffects } from './state/certification-monitoring.effects';



@NgModule({
  declarations: [
    SafetyComponent
  ],
  imports: [
    SafetyRoutingModule,
    SharedModule,
    StoreModule.forFeature('safety', safetyReducer),
    StoreModule.forFeature('certificationMonitoring', certificationMonitoringReducer),
    EffectsModule.forFeature([SafetyEffects, CertificationMonitoringEffects]),
    SafetyWidgetComponent
  ],
  exports: [
    SafetyWidgetComponent]
})
export class SafetyModule { }
